// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../lib/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* this styling will only apply to IE11 */\n@media all and (-ms-high-contrast:none) {\n*[data-v-4e633bf2]::-ms-backdrop, .ui-tabs[data-v-4e633bf2] {\n\t\tflex-basis: auto; /* fixes IE11 issue with tabs not being calculated as part of dialog height */\n}\n}\n", ""]);
// Exports
module.exports = exports;
